import { CHAT_TYPE } from "../../util/varibles/constants";
import { IMessages } from "../../util/varibles/interface";


export enum MESSAGE_TYPE {
    ADD = 'add-notification',
    DELETE = 'delete-notification',
    LEAVE = 'leave-notification'
}

export enum CONVERSATION_MODE {
    CLOSE = 'close',
    OPEN = 'open',
    MINIMIZE = 'minimize'
}

export interface MessageState {
    chat: any[]
    chatIndex: number
    chatNew: number
    loadingChat: boolean
    chatMore: boolean

    operations: any[]
    operationsIndex: number
    operationsNew: number
    loadingOperation: boolean
    operationsMore: boolean

    messages: IMessages
    newConversationType?: CHAT_TYPE
    conversations: any[]
}

export const initialState: MessageState = {
    chat: [],
    chatIndex: 1,
    chatNew: 0,
    loadingChat: false,
    chatMore: false,
    operations: [],
    operationsIndex: 1,
    operationsNew: 0,
    loadingOperation: false,
    operationsMore: false,
    messages: {},
    conversations: []
}


